import {
  EnhancedLabeledSelectControl,
  EnhancedLabeledSelectProps,
  useEnhancedLabeledSelectOverrides,
} from '@gorila-shared-ui/components';
import { ImperativeMethods, Select } from 'baseui/select';
import { useRef, useState } from 'react';
import { REQUIRED_FIELD_TEXT } from '../../constants/app';
import useEffectOnce from '../../hooks/useEffectOnce';

export function EnhancedLabeledSelect({
  value,
  onChange,
  options,
  label,
  searchable = false,
  disabled = false,
  labelKey,
  valueKey,
  fullWidth = false,
  infiniteScroll = false,
  fetchDataLoading = false,
  hasNext = false,
  isMulti = false,
  inset = false,
  fetchData,
  onInputChange,
  filterOptions,
  onBlur,
  clearable = false,
  placeholder,
  selectMaxWidth,
  inline = false,
  maxWidth,
  required = false,
  error,
  caption,
  maxDropdownHeight = '150px',
  smallContainer = false,
  dropdownOffset,
  onBlurResetsInput = false,
  defaultSearch,
}: Readonly<EnhancedLabeledSelectProps & { defaultSearch?: string }>) {
  const controlRef = useRef<ImperativeMethods>(null);
  const [onTouched, setOnTouched] = useState(false);
  const overrides = useEnhancedLabeledSelectOverrides({
    dropdownOffset,
    fetchData,
    fullWidth,
    hasNext,
    infiniteScroll,
    inline,
    inset,
    label,
    maxDropdownHeight,
    selectMaxWidth,
    smallContainer,
  });

  useEffectOnce(() => {
    controlRef.current && defaultSearch && controlRef.current.setInputValue(defaultSearch);
  });

  const handleOnBlur = () => {
    onBlur && onBlur();
    setOnTouched(true);
  };

  return (
    <EnhancedLabeledSelectControl
      caption={caption}
      disabled={disabled}
      error={error ? error : onTouched && required && !value ? REQUIRED_FIELD_TEXT : undefined}
      inline={inline}
      inset={inset}
      label={label}
      maxWidth={maxWidth}
      required={required}
    >
      <Select
        onBlur={handleOnBlur}
        closeOnSelect
        openOnClick
        clearable={clearable}
        onChange={onChange}
        options={options}
        searchable={searchable}
        size={'compact'}
        value={value}
        disabled={disabled}
        labelKey={labelKey}
        valueKey={valueKey}
        onInputChange={onInputChange}
        filterOptions={filterOptions}
        isLoading={fetchDataLoading}
        multi={isMulti}
        maxDropdownHeight={maxDropdownHeight}
        placeholder={placeholder}
        onBlurResetsInput={onBlurResetsInput}
        overrides={overrides}
      />
    </EnhancedLabeledSelectControl>
  );
}
